import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchMyReports, flagReport } from '../api/reports'
import { useAuth } from './useAuth'

export function useMyReports() {
  const { token, isAuthenticated } = useAuth()
  return useQuery({
    queryKey: ['reports', 'mine'],
    queryFn: () => fetchMyReports(token!),
    enabled: isAuthenticated,
    staleTime: 15_000,
  })
}

export function useFlagReport() {
  const { token } = useAuth()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ reportId, reason }: { reportId: string; reason: string }) =>
      flagReport(token!, reportId, reason),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['contacts'] }),
  })
}
